import { tagged } from "@mirage/service-logging";
import Sentry from "@mirage/shared/sentry";
import { replayIntegration } from "@sentry/react";

const logger = tagged("sentryReplay");

export function initSentryReplay(isDev: boolean) {
  if (Sentry && Sentry.addIntegration) {
    if (Sentry.getIntegrationByName?.("Replay")) {
      logger.warn(
        "Sentry Replay integration is already initialized, ignoring.",
      );
      return;
    }

    Sentry.addIntegration(
      replayIntegration({
        sessionSampleRate: isDev ? 1.0 : 0.1, // Adjust the sample rate as needed
        // Additional SDK configuration goes in here, for example:
        maskAllText: true,
        blockAllMedia: true,
        // Allow recording of PAP event request details
        networkDetailAllowUrls: [
          "https://api.dropboxapi.com/2/pap_event_logging/log_events",
        ],
        networkCaptureBodies: true,
        networkResponseHeaders: ["X-Dropbox-Request-Id"],
      }),
    );
  }
}
